<template>
  <div class='service'>
    <!-- <p class='header'><router-link to='/navigator' >首页</router-link> > 人力资源平台</p> -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/navigator/humanResource/sort/jobList' }">{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ childName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <ul class='types'>
      <li v-for='(item, index) in HrTypes' @click='switchService(item.type, item.serviceName)' :key='index' :class='{ "active" : activeIndex === item.type }' class="boxShadow">
        <img :src='item.picUrl'/>
        <span>{{item.serviceName}}</span>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
import JobList from './child/JobList';
import ServiceList from './child/ServiceList';
import EduList from './child/EduList';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      HrTypes: [],
      activeIndex: 0,
      serviceMsg: {},
      childName: '',
    };
  },
  methods: {
    switchService(index, serviceName) {
      this.activeIndex = index;
      this.childName = serviceName;
        if (index === 4) {
        this.$router.push('/navigator/humanResource/sort/jobList');
      } else if (index === 5) {
        this.$router.push('/navigator/humanResource/sort/serviceList');
      } else {
        this.$router.push('/navigator/humanResource/sort/eduList');
      }
    },
    generateService(path) {
      if (path === 'jobList') {
        this.activeIndex = 4;
      } else if (path === 'serviceList') {
        this.activeIndex = 5;
      } else {
        this.activeIndex = 6;
      }
      const obj = this.serviceMsg.children.find((val) => {
        return val.type === this.activeIndex;
      });
      this.childName = obj.serviceName;
    },
    getList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: this.serviceMsg.serviceId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.HrTypes = res.resData ? res.resData.pageList.slice(0,2) : [];
          if (this.$route.path.split('/')[4]) {
            this.generateService(this.$route.path.split('/')[4]);
          } else {
            if (res.resData) {
              this.switchService(this.HrTypes[0].type, this.HrTypes[0].serviceName);
            }
          }
        }
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.generateService(this.$route.path.split('/')[4]);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'parkServiceList']),
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 5;
      });
      this.getList();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.service{
  padding-bottom: 30px;
  .types{
    @include clear-float;
    li{
      float: left;
      width: 410px;
      height: 88px;
      line-height: 88px;
      margin-right: 20px;
      background: #fff;
      cursor: pointer;
      border: 1px solid #f6f6f6;
      &.active{
        border-color: $color-main;
      }
      img, span{
        display: inline-block;
        vertical-align: middle;
      }
      img{
        margin-left: 30px;
        width: 44px;
        height: 44px;
      }
      span{
        margin-left: 20px;
        max-width: 160px;
        @include line-ellipsis;
        font-size: 24px;
        font-weight: 600;
        color: #333333;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/humanResource/components/Sort.vue